"use client";

import { c as _c } from "react/compiler-runtime";
import { useFilter } from "@/components/filters/filter-context";
import { Combobox, ComboboxContent, ComboboxEmpty, ComboboxGroup, ComboboxItem, ComboboxTag, ComboboxTagsInput } from "@/components/ui/combobox";
import { Virtualized, VirtualizedVirtualizer } from "@/components/ui/virtualized";
import { useCallback, useMemo, useState } from "react";
interface ComboboxFilterProps {
  readonly id: string;
  readonly placeholder: string;
  readonly data: string[];
  readonly displayData?: string[];
  readonly defaultValue?: string[];
  readonly uppercase?: boolean;
}
export function ComboboxFilter(t0) {
  const $ = _c(41);
  const {
    id,
    placeholder,
    data,
    displayData,
    defaultValue,
    uppercase
  } = t0;
  const {
    getFilterValues,
    setFilterValues,
    registerDefaultValue
  } = useFilter();
  const [inputValue, setInputValue] = useState("");
  let t1;
  if ($[0] !== defaultValue) {
    t1 = defaultValue ?? [];
    $[0] = defaultValue;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const defaultUsedValue = t1;
  registerDefaultValue(id, defaultUsedValue);
  let t2;
  if ($[2] !== getFilterValues || $[3] !== id) {
    t2 = getFilterValues(id);
    $[2] = getFilterValues;
    $[3] = id;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const values = t2;
  let t3;
  bb0: {
    if (values.length === 1 && values[0] === "") {
      let t4;
      if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = [];
        $[5] = t4;
      } else {
        t4 = $[5];
      }
      t3 = t4;
      break bb0;
    }
    t3 = values;
  }
  const selectedItems = t3;
  let map;
  if ($[6] !== data || $[7] !== displayData) {
    map = new Map();
    const labels = displayData ?? data;
    data.forEach((value, index) => {
      map.set(value, labels[index] ?? value);
    });
    $[6] = data;
    $[7] = displayData;
    $[8] = map;
  } else {
    map = $[8];
  }
  const displayMap = map;
  let t4;
  if ($[9] !== id || $[10] !== setFilterValues) {
    t4 = newValue => {
      setFilterValues(id, newValue);
    };
    $[9] = id;
    $[10] = setFilterValues;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const handleValueChange = t4;
  const unaccent = _temp;
  let t5;
  bb1: {
    const labels_0 = displayData ?? data;
    if (!inputValue) {
      t5 = data;
      break bb1;
    }
    let t6;
    if ($[12] !== data || $[13] !== inputValue || $[14] !== labels_0) {
      const normalizedInput = unaccent(inputValue.toLowerCase());
      t6 = data.filter((item, index_0) => {
        const label = labels_0[index_0] ?? item;
        const normalizedLabel = unaccent(label.toLowerCase());
        return normalizedLabel.includes(normalizedInput);
      });
      $[12] = data;
      $[13] = inputValue;
      $[14] = labels_0;
      $[15] = t6;
    } else {
      t6 = $[15];
    }
    t5 = t6;
  }
  const filtered = t5;
  const t6 = uppercase ? "uppercase" : "";
  let t7;
  if ($[16] !== displayMap || $[17] !== selectedItems) {
    let t8;
    if ($[19] !== displayMap) {
      t8 = value_0 => <ComboboxTag key={value_0} value={value_0}>{displayMap.get(value_0) ?? value_0}</ComboboxTag>;
      $[19] = displayMap;
      $[20] = t8;
    } else {
      t8 = $[20];
    }
    t7 = selectedItems.map(t8);
    $[16] = displayMap;
    $[17] = selectedItems;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[21] !== placeholder || $[22] !== t7) {
    t8 = <ComboboxTagsInput placeholder={placeholder}>{t7}</ComboboxTagsInput>;
    $[21] = placeholder;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== filtered.length) {
    t9 = filtered.length === 0 && <ComboboxEmpty>Sin resultados.</ComboboxEmpty>;
    $[24] = filtered.length;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== displayMap || $[27] !== filtered || $[28] !== uppercase) {
    t10 = filtered.length > 0 && <ComboboxGroup><VirtualizedVirtualizer>{filtered.map(item_0 => <ComboboxItem key={item_0} value={item_0} className={uppercase ? "uppercase" : ""}>{displayMap.get(item_0) ?? item_0}</ComboboxItem>)}</VirtualizedVirtualizer></ComboboxGroup>;
    $[26] = displayMap;
    $[27] = filtered;
    $[28] = uppercase;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== t10 || $[31] !== t9) {
    t11 = <Virtualized asChild={true}><ComboboxContent align="start" className="max-h-75 min-w-75" onWheel={_temp2}>{t9}{t10}</ComboboxContent></Virtualized>;
    $[30] = t10;
    $[31] = t9;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  let t12;
  if ($[33] !== defaultUsedValue || $[34] !== handleValueChange || $[35] !== inputValue || $[36] !== selectedItems || $[37] !== t11 || $[38] !== t6 || $[39] !== t8) {
    t12 = <Combobox inputValue={inputValue} defaultValue={defaultUsedValue} onInputValueChange={setInputValue} onValueChange={handleValueChange} shouldFilter={false} type="multiple" value={selectedItems} className={t6}>{t8}{t11}</Combobox>;
    $[33] = defaultUsedValue;
    $[34] = handleValueChange;
    $[35] = inputValue;
    $[36] = selectedItems;
    $[37] = t11;
    $[38] = t6;
    $[39] = t8;
    $[40] = t12;
  } else {
    t12 = $[40];
  }
  return t12;
}
function _temp2(e) {
  e.stopPropagation();
}
function _temp(str) {
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}